import React, { useState } from "react";
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from "@stripe/stripe-js";

import { useAppSelector } from "hooks/redux";

import { ButtonNew as Button } from "components/buttonNew/index";
import CardSection from "components/cardSection/CardSection";
import Checkbox from "components/form/checkbox/Checkbox";
import { useTranslation } from "react-i18next";

type CreditCardAddProps = {
  isSavingCard: boolean;
  setIsSavingCard: () => void;
  handleStripeInputs: (
    e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
  ) => void;
  onOpenModal?: () => void;
  showFullForm?: boolean;
};


export default function CreditCardAdd(props: CreditCardAddProps) {
  const uiStore = useAppSelector(store => store.uiStore);
  const [isAddingCard, setIsAddingCard] = useState(false);
  const { t } = useTranslation();

  // If modal version, just render nothing and rely on parent to show modal
  const isModalMode = !!props.onOpenModal;

  return (
    <>
      {/* Inline form */}
      {(!isModalMode && isAddingCard) || props.showFullForm ? (
        <div className="flex flex-column">
          <span className="text-xl font-semibold mb-4 mt-2">
            {t("Add Credit Card")}
          </span>
          {(uiStore.newBookingActive || uiStore.editBookingActive) && (
            <CardSection onChange={props.handleStripeInputs} type="one-row" />
          )}
          <Checkbox
            label={t("Save card to customer profile")}
            size="small"
            value={props.isSavingCard}
            checked={props.isSavingCard}
            onChange={props.setIsSavingCard}
          />
        </div>
      ) : null}

      {/* Button */}
      <Button
        type="text"
        onClick={() => {
          if (isModalMode && props.onOpenModal) {
            props.onOpenModal();
          } else {
            setIsAddingCard(!isAddingCard);
          }
        }}
        className="mt-2 mr-auto"
      >
        <span>{!isAddingCard ? t("Add new card +") : t("Cancel")}</span>
      </Button>
    </>
  );
}

